<div class="row">
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <input type="text" class="form-control" placeholder="검색어"
                [(ngModel)]="searchValue"
                (keyup.enter)="keyupEnterSearchValue($event)">
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary"
                    (click)="clickSearch()">
                    <i class="fas fa-search"></i>
                    <span class="ml-1">
                        검색
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <input type="text" class="form-control" placeholder="차량선택"
                [(ngModel)]="dtgCarNo"
                (click)="clickOpenModalGeofenceCarList(DtgActionType.read)"
                readonly>
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary"
                    (click)="clickOpenModalGeofenceCarList(DtgActionType.read)">
                    <i class="fas fa-search"></i>
                    <span class="ml-1">
                        차량검색
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <input type="text" class="form-control" placeholder="주소 중 일부"
                [(ngModel)]="dtgGpsAddr"
                (keyup.enter)="keyupEnterSearchValue($event)">
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary"
                    (click)="clickSearch()">
                    <i class="fas fa-search"></i>
                    <span class="ml-1">
                        검색
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="col"></div>
</div>

<div class="table-responsive mt-3">
    <table class="table table-sm table-hover align-items-center mb-0">
        <thead class="">
            <th>
                차량번호
            </th>
            <th>
                시작일시
            </th>
            <th>
                종료일시
            </th>
            <th>
                정차시간
            </th>
            <th>
                RPM
            </th>
            <th>
                주소
            </th>
            <th [hidden]="listType === DtgListType.modal">
                상세
            </th>
        </thead>
        <tbody class="">
            <tr *ngFor="let item of listTeam;">
                <td>
                    <span>{{item.dtgCarNo}}</span>
                </td>
                <td>
                    <span>{{item.dtgRegDtFrom | date:'yyyy-MM-dd HH:mm:ss' || '-'}}</span>
                </td>
                <td>
                    <span>{{item.dtgRegDtTo | date:'yyyy-MM-dd HH:mm:ss' || '-'}}</span>
                </td>
                <td>
                    <span>{{item.dtgOverSec | filterSecToTime}}</span>
                </td>
                <td>
                    <span>{{item.dtgCheckRpm + item.dtgOverRpm | number}}</span>
                </td>
                <td>
                    <span>{{item.dtgGpsAddrFrom}}</span>
                </td>
                <td [hidden]="listType === DtgListType.modal">
                    <button type="button" class="btn btn-sm btn-outline-secondary"
                        (click)="clickOpenModalStopHighRpmDetail(dtgActionType.read,item)">
                        <i class="mdi mdi-pen"></i>
                        <span class="ml-1">상세</span>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<div class="mt-3">
    <list-paging
        [inputPagingInfo]="pagingInfo"
        (callbackClickPageNumber)="callbackClickPageNumber($event)"
        (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
</div>
